// @flow

export {
  PROP_ID,
  PROP_CLIENT,
  PROP_ADDRESS,
  PROP_CITY,
  PROP_PROVINCE,
  PROP_POSTAL_CODE,
  PROP_COUNTRY,
  PROP_PHONE,
  PROP_MOBILE_PHONE,
  PROP_EMAIL,
  PREFERRED_CONTACT,
  PROP_ORDERED_DATE,
  PROP_CALCULATED_SALES_TAX,
  PROP_SUPPLY_QUANTITY,
  PROP_SHIPPING_PACKAGE_TYPE,
  BOX,
  BAG,
  ORDER_TOTAL,
  SUPPLIES,
  MODEL,
  URL,
  TREE,
  BRANCH,
  OPERATIONS_BRANCH,
  OPERATIONS_TREE,
  PROP_ORDER,
  PROP_USER_BILLING_INFO,
  PROP_IS_LOADING,
  PROP_PAYMENT_SESSION_ID,
  PROP_CLIENT_SECRET,
} from './constants'
